module.exports = __webpack_public_path__ + "img/驳回1.45eb87fc.svg";